import React, { FormEvent, useState } from "react";
import "./ClientProjectModal.css";
import { ClientProject } from "../types";

interface ClientProjectModalProps {
  isOpen: boolean;
  onClose: () => void;
  clientProjects: ClientProject[];
  onCreateClientProject: (name: string) => boolean;
}

const ClientProjectModal: React.FC<ClientProjectModalProps> = ({
  isOpen,
  onClose,
  clientProjects,
  onCreateClientProject,
}) => {
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);

  if (!isOpen) return null;

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const created = onCreateClientProject(name);
    if (!created) {
      setError("Client project name already exists or is invalid.");
      return;
    }
    setError(null);
    setName("");
  };

  return (
    <div className="client-project-modal-overlay" onClick={onClose}>
      <div
        className="client-project-modal"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="client-project-modal-header">
          <h2>🏷️ Client Projects</h2>
          <button type="button" className="client-project-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <form className="client-project-form" onSubmit={handleSubmit}>
          <label htmlFor="client-project-name">New client project</label>
          <div className="client-project-create-row">
            <input
              id="client-project-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Acme Website Program"
            />
            <button type="submit">Create</button>
          </div>
          {error && <p className="client-project-error">{error}</p>}
        </form>

        <div className="client-project-list-section">
          <h3>Existing client projects</h3>
          {clientProjects.length === 0 ? (
            <p className="client-project-empty">No client project yet.</p>
          ) : (
            <ul className="client-project-list">
              {clientProjects.map((clientProject) => (
                <li key={clientProject.id}>{clientProject.name}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClientProjectModal;
